﻿import * as angular from "angular";
import * as QRCode from "qrcode";

import DataService from "../Services/DataService";

interface TwoFactorModel {
    authValues?: string;
    rawAuthValues?: string;
}

interface TwoFactorActions {}

interface TwoFactorScope extends angular.IScope {
    model: TwoFactorModel;
    actions: TwoFactorActions;
}

class TwoFactorController {
    private $scope: TwoFactorScope;
    private $rootScope: angular.IRootScopeService;
    private dataService: DataService;

    constructor(
        $scope: TwoFactorScope,
        $rootScope: angular.IRootScopeService,
        dataService: DataService,
    ) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.dataService = dataService;

        $scope.model = { authValues: "", rawAuthValues: "" };

        $scope.actions = {};

        this.initialise();
    }

    private async initialise() {
        const configuration = await this.dataService.twoFactorInit(
            Reflect.get(globalThis, "requestId"),
            Reflect.get(globalThis, "secret"),
        );

        this.$scope.model.rawAuthValues = configuration.item1;
        for (let index = 0; index < configuration.item1.length; index++) {
            this.$scope.model.authValues =
                this.$scope.model.authValues + configuration.item1[index];
            if ((index + 1) % 4 === 0)
                this.$scope.model.authValues =
                    this.$scope.model.authValues + " ";
        }

        const container = document.querySelector<HTMLElement>("#qrcode");
        if (container) {
            container.innerHTML = "";

            const canvas = document.createElement("canvas");
            await QRCode.toCanvas(canvas, configuration.item2, {
                width: 192,
                margin: 1,
            });
            container.appendChild(canvas);
        }

        if (!this.$rootScope.$$phase) this.$scope.$apply();

        document.querySelector<HTMLInputElement>("#txtAuthResponse")?.focus();
    }
}

angular
    .module("datastore")
    .controller("TwoFactorController", [
        "$scope",
        "$rootScope",
        "dataService",
        TwoFactorController,
    ]);

export default TwoFactorController;
